import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import TenDash from "./TenDash";
import TenPayNow from "./TenPayNow";
import TenPayHist from "./TenPayHist";
import TenMaintList from "./TenMaintList";
import TenSubMaint from "./TenSubMaint";
import TenChatPage from "./TenChatPage";
import SettingsPage from "../landlord/SettingsPage";
import FaqPage from "../landlord/FaqPage";
import TenLeasePage from "./TenLeasePage";
import MapViewPage from "../common/MapViewPage";
import ProfilePage from "../common/ProfilePage";
import TermsPage from "../common/TermsPage";
import PrivacyPage from "../common/PrivacyPage";

function TenantPage() {
  const { page } = useContext(Ctx);
  switch (page) { case "dash": return <TenDash />; case "pay": return <TenPayHist />; case "maint": return <TenMaintList />; case "tenChat": return <TenChatPage />; case "settings": return <SettingsPage />; case "tenPay": return <TenPayNow />; case "subMaint": return <TenSubMaint />; case "faq": return <FaqPage />; case "tenAgr": return <TenLeasePage />; case "tenLease": return <TenLeasePage />; case "mapView": return <MapViewPage />; case "profile": return <ProfilePage />; case "terms": return <TermsPage />; case "privacy": return <PrivacyPage />; default: return <TenDash />; }
}

export default TenantPage;
